<template>
  <div>
    <div v-if="userDetails.gamesPlayed === 0">
      <div class="soccer_background">

        <div class="performance_box empty">
          <h1>{{ getTranslations.home_profile_default_content_your_performance }}</h1>
          <img src="/static/images/profile/profile-emptystate.png">
          <p>{{ getTranslations.home_profile_profile_performance_empty }}</p>
        </div>

        <div class="performance_box empty">
          <h1>{{ getTranslations.home_profile_profile_your_achievements }}</h1>
          <img src="/static/images/profile/profile-emptystate.png">
          <p>{{ getTranslations.home_profile_profile_achievements_empty }}</p>
        </div>


      </div>

    </div>
    <div v-else>
      <section class="performance_box">
          <h1>{{ getTranslations.home_profile_default_content_your_performance }}</h1>
        <div class="profile__block__content profile__block__content--your-performance">
          <!--<div class="avatar-cont">-->
          <!--<img :src="userDetails.avatar" alt="">-->
          <!--</div>-->
          <div class="stats-cont">
            <div class="performance_bg">
              <div class="performance_row_title">
                <h2>{{ getTranslations.home_profile_profile_games }}</h2>
              </div>
              <div class="performance_row_text"></div>
              <div class="progressbar">
                <p>{{ gamesWonPercentRatio }}% ({{ numberFormatting(userDetails.correctAnswersGiven)
                  }}/{{ numberFormatting(userDetails.answersGiven)
                  }} {{ getTranslations.home_profile_default_content_correct_answers
                  }})</p>
                <div id="gamesWon" class="progressbar__bar"></div>
              </div>

            </div>
            <div class="performance_bg" v-if="addOnMode.text !== 'HIDE'" style="">
              <div class="performance_row_title" >
                <h2>{{ getTranslations.home_profile_default_content_answers }}</h2>
              </div>
              <div class="performance_row_text"></div>
              <div class="progressbar">
                <p>{{ correctAnswersPercentRatio }}% ({{ numberFormatting(userDetails.penaltyScored)
                  }}/{{ numberFormatting(userDetails.penaltyNo)
                  }})</p>
                <div id="correctAnswers" class="progressbar__bar"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="get_started_list_section achievements_section">
          <div class="main_title"><h1>{{ getTranslations.home_profile_profile_your_achievements }}</h1></div>

<!--          <div class="filter achievements_filter">-->

<!--            <a class="all current" href="#">{{ getTranslations.home_profile_profile_all }}</a>-->
<!--            <a class="weekly" href="#">{{ getTranslations.home_profile_profile_pending }}</a>-->
<!--            <a class="monthly" href="#">{{ getTranslations.home_profile_profile_completed }}</a>-->

<!--          </div>-->
          <div class="filter_list">

            <div class="list_item weekly" style="">
              <!-- list item -->
              <div class="achievement_row">
                <div class="img_achievement">
                  <img src="/static/images/achievements/achievement_1.png">
                </div>
                <div class="achievement_col">
                  <h1>{{ getTranslations.home_profile_profile_games_completed }}

                  </h1>
                  <p>{{userDetails.answersGiven}} {{ getTranslations.home_profile_profile_games_completed }}</p>
                </div>
                <div :class=progressCss :data-percent="gamesWonPercentRatio">
                  <svg class="progress" width="178" height="178" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0"></circle>
                    <circle class="bar" r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0"></circle>
                  </svg>
                </div>
              </div>
              <!-- end list item -->
            </div>
            <div class="list_item monthly" v-if="addOnMode.text !== 'HIDE'" style="">
              <!-- list item -->
              <div class="achievement_row">
                <div class="img_achievement">
                  <img src="/static/images/achievements/achievement_2.png">
                </div>
                <div class="achievement_col">
                  <h1>{{ getTranslations.home_profile_profile_games_completed }}</h1>
                  <p> {{userDetails.penaltyNo}} {{ getTranslations.home_profile_profile_games_completed }}</p>
                </div>
                <div :class="progressCss1" :data-percent="correctAnswersPercentRatio">
                  <svg class="progress" width="178" height="178" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0"></circle>
                    <circle class="bar" r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0"></circle>
                  </svg>
                </div>
              </div>
              <!-- end list item -->
            </div>

            <div class="load_more_btn">
              <button  class="load-more btn2 btn2--std btn2--small" @click="changeStatus">···</button>
            </div>

          </div>

        </div>
      </section>
    </div>
  </div>
</template>


<script>

  /* eslint no-param-reassign: ["error", { "props": false }], no-console: "off" */
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import 'owl.carousel';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import { updateProgressBarGamesWon, updateProgressBarAnswersPercent, profileBar } from '@/common/jQuery';
import modals from '@/common/modals';
import ProfileStats from './ProfileStats';

export default {
  name: 'profile-default-content',
  mixins: [NumbersFormattingMixin],
  data() {
    return {
      progressCss: 'progressdiv small',
      progressCss1: 'progressdiv small',
    };
  },
  components: {
    ProfileStats,
  },
  mounted() {
    profileBar();
    /* eslint-disable */
    $(".progressbar__bar").each(function (t, e) {
      var n = $(e).data("percent");
      $(e).width(n + "%")
    })
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  created() {
    if (this.gamesWonPercentRatio === 100){
      this.progressCss = 'progressdiv small complete'
    }
    if (this.correctAnswersPercentRatio === 100){
      this.progressCss1 = 'progressdiv small complete'
    }
    this.fetchData();
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    changeStatus() {
      return this.$router.push('/home/achievements');
    },
    playMethod() {
      console.log('showing resume game pop up in DefaultContentProfile Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
        } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForHomePage(ResubscribeGameSms);
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
          } else {
            this.storeModalForHomePage(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForHomePage(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForHomePage(null);
        }
        modals.showHideModal(this);
      }).catch(error => console.error(error));
    },
    fetchData() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.theme-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          autoplay: false,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.carousel__dots',
          navText: ['<i   class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
          responsive: {
            0: {
              items: 4,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index == 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index == (event.item.count - 4)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        })
      });
      /* eslint-enable */
    },
    renderProgressBar() {
      // console.clear();
      this.$nextTick(() => {
        updateProgressBarGamesWon(this.gamesWonPercentRatio);
        updateProgressBarAnswersPercent(this.correctAnswersPercentRatio);
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'reoptinAndOptoutConfig',
      'subAndUnsubViaSMS',
      'addOnMode',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    gamesWonPercentRatio() {
      return (this.userDetails.correctAnswersGiven / this.userDetails.answersGiven) ? Math.round((this.userDetails.correctAnswersGiven / this.userDetails.answersGiven) * 100) : 0;
    },
    correctAnswersPercentRatio() {
      return (this.userDetails.penaltyScored / this.userDetails.penaltyNo) ? Math.round((this.userDetails.penaltyScored / this.userDetails.penaltyNo) * 100) : 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/DefaultContentProfile.vue